import React from "react";
import { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { MyTextInput } from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { login } from "../services/web/webServices";

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [getButton, setButton] = useState(true);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const css = `
.login-container {
  max-width: 450px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  marginTop:220px;
  background-color: #263043
}

h2 {
  text-align: center; 
  margin-bottom: 20px;
}

form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: bold;
}

input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
}

button {
  padding: 12px;
  background-color: #076A33;
   
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  
}

button:hover {
  background-color: #076A33;
}
  forgot-password{
        display:flex;
        justiy-content:right;
  }

  `;

  // comment backgroundImage: `url(images/image1.png)`,
  // src="./images/logo.png"
  return (
    <>
      <style>{css}</style>
      <div
        style={{
          backgroundImage: `url(/images/image1.png)`,
          height: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "100px",
        }}
      >
        <div>
          <div className="login-container">
            <img
              src="/images/logo.png"
              alt="logo"
              style={{ margin: "30px", marginLeft: "65px" }}
            />
            <h2 style={{ fontSize: "40px", color: "#fff" }}>Login</h2>
            <Formik
              initialValues={{
                email: "",
                password: "",
              }}
              validationSchema={Yup.object({
                email: Yup.string()
                  .email("Please Enter Email")
                  .matches(
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    "Please Enter Valid Email"
                  )
                  .required("Please Enter Email"),
                password: Yup.string().required("Please Enter Password"),
              })}
              onSubmit={(values, { resetForm }) => {
                setButton(false);
                const normalizedValues = {
                  ...values,
                  email: values.email.toLowerCase(),
                };

                login(normalizedValues)
                  .then((res) => {
                    console.log("Login success:", res);
                    setButton(true);

                    Store.addNotification({
                      title: "Success",
                      message: res.data?.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animate__animated", "animate__fadeIn"],
                      animationOut: ["animate__animated", "animate__fadeOut"],
                      dismiss: {
                        duration: 5000,
                        onScreen: true,
                      },
                    });
                    resetForm({ values: "" });
                    localStorage.setItem("auth_token_travel", res?.data?.token);
                    navigate("/dashboard");
                  })
                  .catch((error) => {
                    setButton(true);
                    if (error) {
                      Store.addNotification({
                        title: "Error!",
                        message: error?.response?.data?.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                    }
                  });
              }}
            >
              {(props) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <MyTextInput
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter your email"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <div className="password-input">
                      <MyTextInput
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        placeholder="Enter your password"
                      />
                      <span
                        className="toggle-password"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>

                  <div
                    className="forgot-password"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginBottom: "10px",
                      textDecoration: "none",
                    }}
                  >
                    <Link
                      to="/forgotPassword"
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        fontSize: "18px",
                        color: "#fff",
                      }}
                    >
                      {" "}
                      Forgot Password?
                    </Link>
                  </div>
                  {getButton === true ? (
                    <button
                      type="submit"
                      style={{ fontSize: "20px", color: "#fff" }}
                    >
                      Login
                    </button>
                  ) : (
                    <button
                      type="submit"
                      style={{ fontSize: "20px", color: "#fff" }}
                      disabled={!getButton}
                    >
                      Please Wait!!
                    </button>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
